import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Config from 'config'
import HttpProvider from '@/services/HttpProvider'
import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'

dayjs.extend(localeData)

Vue.use(VueI18n)

export let ajaxMessages = null

export let i18n

let loadedMesg = {}
let promiseArr = {}

function loadAsyncMsg (locale, storeviewcode, localeCountry) {
  if (promiseArr[locale]) {
    return promiseArr[locale]
  }
  if (loadedMesg[locale]) {
    return Promise.resolve(loadedMesg[locale])
  }
  promiseArr[locale] = HttpProvider.get(
    Config.API.locale
      .replace(/{{storeViewCode}}/g, storeviewcode)
      .replace('{{locale}}', localeCountry))
    .then(res => {
      if (res.data[0]) {
        return res.data[0]
      } else {
        return require('theme/i18n/it.json')
      }
    })
    .finally(() => {
      promiseArr[locale] = null
    })
  return promiseArr[locale]
}

export async function loadLanguageAsync (locale, storeviewcode, localeCountry) {
  let message = {}
  if (process.env.VUE_APP_LOCALEDB === 'false') {
    message = require(`theme/i18n/${locale}.json`)
  } else {
    message = await loadAsyncMsg(locale, storeviewcode, localeCountry)
  }

  loadedMesg[locale] = { ...loadedMesg[locale], ...message }

  try {
    const localesMap = {
      'it': require('dayjs/locale/it'),
      'en': require('dayjs/locale/en')
    }
    let currentLocale = localesMap[locale] ? localesMap[locale] : localesMap['en']
    dayjs.locale(currentLocale)
  } catch (e) {
    console.error('cannot load locale')
  }
  i18n.setLocaleMessage(locale, loadedMesg[locale])
  return loadedMesg[locale]
}

export default (store) => {
  const localeComplete = store.state.ui.locale ? store.state.ui.locale : process.env.VUE_APP_I18N_LOCAL
  const language = localeComplete.substr(0, 2) || 'en'
  if (Object.keys(store.state.ui.messages).length) {
    loadedMesg = { [language]: store.state.ui.messages }
  }
  global.$i18n = new VueI18n({
    locale: language,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadedMesg
  })
  i18n = global.$i18n
  return global.$i18n
}
